import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { API_ENDPOINTS } from "../../../constant/_constant";
import usePostRequest from "../../../hooks/usePostRequest";
import moment from "moment";
import { IconCalendarWeekFilled, IconMailSpark } from "@tabler/icons-react";
import Lottie from "lottie-react";
import notfoundData from '../../../assets/not_found.json';
import {
  Button,
  Table,
  Card,
  Col,
  Form,
  Row,
  InputGroup,
  FormText,
  textarea,
  Tab,
  Tabs,
  Spinner,
  ButtonGroup,
} from "react-bootstrap";
import { trimTrailingZeros } from "../../../utils/_helpers";
function EmailHistory({ setShow, show, rfq_id }) {
  const {
    data: EmailHISTORY_DATA,
    isLoading: EmailHISTORY_LOADING,
    postData: fetchEmails,
  } = usePostRequest(API_ENDPOINTS.EMAIL_HISTORY_PROJECT);

  useEffect(() => {
    fetchEmails({ rfq_id: rfq_id });
  }, []);

  return (
    <Modal
    scrollable={true}
      show={show}
      onHide={() => setShow({ show: false })}
      dialogClassName="modal-90w"
      size="lg"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="gap-2" closeButton>
        <span className="avatar bg-orange-lt rounded-circle">
          <IconMailSpark stroke={1.25} />
        </span>
        <div>
          <Modal.Title>Email History</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
       
        {EmailHISTORY_DATA && EmailHISTORY_DATA.data.length > 0 ? (
          EmailHISTORY_DATA?.data.map((item, index) => {
            return (
              <>

              <div className="mail_wrapper" key={index}>
              <Row>
                  <Col md={6}>
                    <div className="mail_head_item">
                      <p className="mb-0"><strong>Project No:</strong> {rfq_id}</p>
                      <p className="mb-0"><strong>Sent To:</strong> {item?.to_email}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                  <div className="mail_head_item">
                    <p className="mb-0 text-end d-flex align-items-center gap-1 justify-content-end"><IconCalendarWeekFilled stroke={1} width={20} /> {moment(item?.latest_date).format("MM/DD/YYYY")}</p>
                    <p className="mb-0 text-end"><strong>From: </strong> {item?.from_email}</p>
                  </div>
                  </Col>
                </Row>
                <hr/>

                <p style={{borderTop:"solid 1px #ddd;"}}
                    dangerouslySetInnerHTML={{
                      __html: item?.body || "",
                    }}
                  ></p>
                <Row>

                  <div className="table-responsive">

                    {item?.sku_data && ( <Table bordered >
                      <thead>
                        <tr>
                          <th> Vendor/Partner</th>
                          <th> SKU ID</th>
                          <th> SKU Desc</th>
                          <th> QTY</th>
                          <th> Unit Cost($)</th>
                          <th> Total Cost($)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {item?.sku_data?.map((P, index) => (
                          <tr key={index}>
                            <td>{P?.Vendor?.display_name}</td>
                            <td>{P?.sku_id}</td>
                            <td>{P.description}</td>
                            <td>{trimTrailingZeros(P.quantity)}</td>
                            <td>
                              {Number(P.customer_price).toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </td>
                            <td>
                              {Number(P.total_price).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan={4}></td>
                          <td>
                            <strong>SUB TOTAL</strong>
                          </td>
                          <td>
                            <strong>
                              $
                              {item.sku_data?.reduce(
                                  (total, current) =>
                                    total + Number(current.total_price),
                                  0
                                )}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </Table>)}
                   
                  </div>
                </Row>
              </div>
         
              </>
            );
          })
        ) : (
           <div className="data_not_available text-center pb-4"> <Lottie animationData={notfoundData}/> <p> No History Available</p>  </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default EmailHistory;
